export const PROFILE_DRAFT_DISPLAY_EVENT = "captureez:profile-draft-display";
export const PROFILE_DRAFT_CLEAR_EVENT = "captureez:profile-draft-clear";

export const buildProfileDraftDisplay = ({
  name = "",
  photoURL = "",
} = {}) => ({
  id: "profile-draft",
  name: String(name || "").trim() || "New profile",
  photoURL: photoURL || "",
  isDraftProfile: true,
});

export const dispatchProfileDraftDisplay = (draft = {}) => {
  if (typeof window === "undefined") return;
  const displayDraft = buildProfileDraftDisplay(draft);
  window.dispatchEvent(new CustomEvent(PROFILE_DRAFT_DISPLAY_EVENT, {
    detail: displayDraft,
  }));
};

export const clearProfileDraftDisplay = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PROFILE_DRAFT_CLEAR_EVENT));
};
